// extracted by mini-css-extract-plugin
export const contactContainer = "contactStyles-module--contactContainer--3gO9Q";
export const authorLogo = "contactStyles-module--authorLogo--Yh3Xe";
export const contactContainerImg = "contactStyles-module--contactContainerImg--3qkkI";
export const contactAnimation = "contactStyles-module--contactAnimation--3sodf";